var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProfileImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.214,
    y1: 0.074,
    x2: 0.859,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1eb4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#105ffb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_Profile",
    "data-name": "User Profile",
    transform: "translate(-1107 -363)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 58.5,
    cy: 58.5,
    r: 58.5,
    transform: "translate(1107 363)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M60.645,41.813a30.853,30.853,0,0,0-7.869-4.926,2.573,2.573,0,0,0-2.09,4.7,25.733,25.733,0,0,1,6.562,4.089,10.26,10.26,0,0,1,3.476,7.712v4.76a2.576,2.576,0,0,1-2.573,2.573H7.719a2.576,2.576,0,0,1-2.573-2.573v-4.76a10.26,10.26,0,0,1,3.476-7.712c2.6-2.285,10.174-7.6,24.313-7.6a19.063,19.063,0,1,0-11.6-3.951A35.772,35.772,0,0,0,5.225,41.813,15.406,15.406,0,0,0,0,53.391v4.76A7.728,7.728,0,0,0,7.719,65.87H58.151a7.728,7.728,0,0,0,7.719-7.719v-4.76A15.406,15.406,0,0,0,60.645,41.813ZM19.04,19.04A13.894,13.894,0,1,1,32.935,32.935,13.91,13.91,0,0,1,19.04,19.04Zm0,0",
    transform: "translate(1132.565 388.565)",
    fill: "#f4feff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileImage);
export default __webpack_public_path__ + "static/media/default-profile-image.56d4dd4334fcc504046b0952e4a742f9.svg";
export { ForwardRef as ReactComponent };